import { render } from "./Index.vue?vue&type=template&id=cc799cc4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=cc799cc4&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=cc799cc4&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc799cc4"]])

export default __exports__